/**
 * Schema definitions for RewardAttributes components
 * Contains UI schemas for date pickers and toggle components
 */

import { DATE_VALIDATION_TYPE } from '@/utils/constants/commonConstants'

/**
 * Schema for Start Date DatePickerInput
 * @param {Object} formData - Form data containing endDateDisplay
 * @returns {Object} Start date schema configuration
 */
export const getStartDateSchema = (formData) => ({
  label: 'Start Date',
  placeholder: 'Start Date',
  required: true,
  className: 'w-full',
  validationRules: [
    {
      type: DATE_VALIDATION_TYPE.START_DATE,
      msg: 'must be a future date.'
    },
    {
      type: DATE_VALIDATION_TYPE.START_DATE_TODAY,
      msg: 'must be a future date.'
    },
    {
      type: DATE_VALIDATION_TYPE.START_DATE_REQUIRED_IF_END_DATE,
      endDate: formData && formData.endDateDisplay,
      msg: 'Please select a start date before selecting an end date.',
      excludeLabel: true
    }
  ],
  disabled: false,
  dependentDate: formData && formData.endDateDisplay, // For validation dependency
})

/**
 * Schema for End Date DatePickerInput
 * @param {Object} formData - Form data containing startDateDisplay
 * @returns {Object} End date schema configuration
 */
export const getEndDateSchema = (formData) => ({
  label: 'End Date',
  placeholder: 'End Date',
  required: true,
  className: 'w-full',
  validationRules: [
    {
      type: DATE_VALIDATION_TYPE.START_DATE,
      msg: 'must be a future date.'
    },
    {
      type: DATE_VALIDATION_TYPE.START_DATE_TODAY,
      msg: 'must be a future date.'
    },
    {
      type: DATE_VALIDATION_TYPE.END_DATE,
      startDate: formData && formData.startDateDisplay,
      msg: 'cannot be earlier than the start date.'
    },
    {
      type: DATE_VALIDATION_TYPE.END_DATE_REQUIRED_IF_START_DATE,
      startDate: formData && formData.startDateDisplay,
      msg: 'Please select an end date.',
      excludeLabel: true
    }
  ],
  disabled: false,
  dependentDate: formData && formData.startDateDisplay, // For validation dependency
})

/**
 * Schema for Display Out of Stock Toggle
 */
export const displayOutOfStockSchema = {
  label: 'Display Out of Stock',
  size: 'medium',
  isDark: true,
  variant: 'horizontal',
  showCheckedIcon: true,
  className: 'w-full',
}

/**
 * Schema for In Stock Toggle
 */
export const inStockSchema = {
  label: 'In Stock',
  size: 'medium',
  isDark: true,
  variant: 'horizontal',
  showCheckedIcon: true,
  className: 'w-full',
}

/**
 * Schema for Unlimited Inventory Toggle
 */
export const unlimitedInventorySchema = {
  label: 'Unlimited Inventory',
  size: 'medium',
  isDark: true,
  variant: 'horizontal',
  showCheckedIcon: true,
  className: 'w-full',
}
